import React from "react";
const SpamhausEDROPAdapterDocumentation = () => /* @__PURE__ */ React.createElement("div", null);
export default SpamhausEDROPAdapterDocumentation;
